import { InitialAccountContext } from './types';

export const initialAccountContextState: InitialAccountContext = {
  account: {
    id: null,
    dismissedBanners: [''],
    currentOrganization: {
      id: null,
      isOneBufferOrganization: true,
      createdAt: null,
      channels: [],
      commonTrackingProperties: {
        atEventBillingState: null,
        atEventBillingPlan: null,
        atEventBillingCycle: null,
        atEventBillingGateway: null,
        atEventIsNewBuffer: null,
        atEventChannelQty: null,
      },
      dismissedObjects: [],
      billing: {
        canStartTrial: false,
        subscription: {
          interval: null,
          plan: {
            id: null,
          },
        },
        changePlanOptions: [
          {
            planId: null,
            planInterval: null,
            isRecommended: false,
          },
        ],
        gateway: {
          gatewayType: null,
        },
        paymentDetails: {
          hasPaymentDetails: false,
        },
      },
      role: '',
      limits: {
        ideas: 0,
      },
    },
  },
};
